import { css } from "@emotion/react";
import emotionStyled from "@emotion/styled";
import { Button } from "@material-ui/core";

const Card = emotionStyled.div`
  box-sizing: border-box;
  width: 100%;
  background-color: white;
  position: relative;
  border-radius: 10px;
  background-color: white;
  box-shadow: rgba(49, 53, 59, 0.15) 0px 1px 6px 0px;
  padding: 1rem;
`

const Typography = emotionStyled.div`
  font-family: Inter;
  letter-spacing: 0em;
  text-align: left;
`

export const TypoTitle = emotionStyled(Typography)`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #202939;
`

export const TypoSubTitle = emotionStyled(Typography)`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #4B5565;
`

export const HelperText = emotionStyled(Typography)`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0em;
  text-align: left;
  color: rgba(105, 117, 134, 1);
`

export const BiodataContainer = emotionStyled.div`
  flex: 1;
  background-color: white;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`

export const BiodataWrapper = emotionStyled.div`
  width: 100%;
  flex: 1;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  @media screen and (min-width: 768px) {
    flex-direction: row;
  }
`

export const ProfileWrapper = emotionStyled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`

export const ProfilePictureWrapper = emotionStyled(Card)`
  box-sizing: border-box;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const ImageWrapper = emotionStyled.div`
  width: 100%;
  & > div {
    width: inherit;
    border-radius: 10px;
  }
  & img {
    width: 100%;
    border-radius: 10px;
  }
`

export const UploadButton = emotionStyled(Button)`
  align-self: flex-end !important;
  display: flex !important;
  height: 44px !important;
  padding: 10px 18px !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 8px !important;
  align-self: stretch !important;
  border-radius: 8px !important;

  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05) !important;
  text-transform: capitalize !important;
  font-family: Inter !important;
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: 24px !important;

  ${({ primary, disabled }) => {
    if (disabled) {
      return css`
        border: none !important;
        color: rgba(0, 0, 0, 0.26) !important;
        box-shadow: none;
        background-color: #cad3e1 !important;
      `
    }
    if (primary) {
      return css`
      border: none !important;
      background: #0068E1 !important;
      color: #FFF !important;
      `
    }
    else {
      return css`
        border: 1px solid #141414 !important;
        background: #fff !important;
        color: #364152 !important;
      `
    }
  }}
`;

export const AccountBiodataInformationWrapper = emotionStyled(Card)`
  display: flex;
  flex-direction: column;
  gap: .75rem;
  & > .btn-group-profile {
    margin-top: 1rem;
    .btn-fb {
      text-transform: none;
      color: #3f62a9;
    }
    .btn-help {
      text-transform: none;
      color: #2bb140;
    }
  }
`

export const BiodataDetails = emotionStyled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  @media screen and (min-width: 768px) {
    max-width: calc(100% - 300px);
  }

  @media screen and (min-width: 1224px) {
    max-width: calc(100% - 300px);
  }
`

export const BiodataDetailHeader = emotionStyled.div`
  font-weight: 700;
  font-size: 14px;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 1rem;

  &>.title{
  }
  &>.action{
    margin-left: auto;
    cursor: pointer;
    color: #015EB6;
  }
`

export const BiodataDetailContent = emotionStyled.div`
  width: inherit;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const BiodataDetailContentItem = emotionStyled.div`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  color: rgba(75, 85, 101, 1);

  display: flex;
  flex-direction: row;
  gap: 1rem;
  justify-content: space-between;
  align-items: center;
  
  & span {
    overflow: hidden;
    text-overflow: ellipsis;
    text-wrap: wrap;
  }

  & > span {
    width: 30%;
  }
  
  & > span:nth-child(2) {
    flex: 1;
  }
`

export const BiodataButton = emotionStyled(Button)`
  align-self: flex-end !important;
  display: flex !important;
  height: 44px !important;
  padding: 10px 18px !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 8px !important;
  align-self: stretch !important;
  border-radius: 8px !important;

  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05) !important;
  text-transform: capitalize !important;
  font-family: Inter !important;
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: 24px !important;

  ${({ primary, disabled }) => {
    if (disabled) {
      return css`
        border: none !important;
        color: rgba(0, 0, 0, 0.26) !important;
        box-shadow: none;
        background-color: #cad3e1 !important;
      `
    }
    if (primary) {
      return css`
      border: none !important;
      background: #0068E1 !important;
      color: #FFF !important;
      `
    }
    else {
      return css`
        border: 1px solid #141414 !important;
        background: #fff !important;
        color: #364152 !important;
      `
    }
  }}
`;

export const BiodataItem = emotionStyled.div``

export const Content = emotionStyled.div`
  width: auto;
  margin: 0 auto;
  display: flex;
`

export const FooterContent = emotionStyled(Content)`
  position: sticky;
  bottom: 0;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
`